import { createSelector } from '@reduxjs/toolkit';
import { tabSetReducer as tabSet } from '../../../features/tab-set/tab-set-slice.js';
import { loadReducerError } from '../../../utils/errors.js';
import { buildController, } from '../../controller/headless-controller.js';
/**
 * @internal
 */
export function buildCoreTabManager(engine) {
    if (!loadTabReducers(engine)) {
        throw loadReducerError;
    }
    const controller = buildController(engine);
    const currentTab = createSelector((state) => state.tabSet, (state) => {
        const activeTab = Object.values(state).find((tab) => tab.isActive);
        return activeTab?.id ?? '';
    });
    return {
        ...controller,
        get state() {
            return { activeTab: currentTab(engine.state) };
        },
    };
}
function loadTabReducers(engine) {
    engine.addReducers({ tabSet });
    return true;
}
